/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TreatmentTypeEnum } from './treatmentTypeEnum';


import {ValidatorFn, Validators} from "@angular/forms";

export interface TreatmentType { 
    readonly treatmentTypes: Array<TreatmentTypeEnum>;
}
export const TreatmentType_treatmentTypes_Validators: ValidatorFn[] =
    [  Validators.required, ];


